import * as React from 'react'

export type EditableSimulationTransactionColumns = {
  areaCode?: boolean
  deliveryPeriodType?: boolean
  deliveryDateRange?: boolean
  deliveryHourType?: boolean
  unitPricePerKwh?: boolean
  volumeInKw?: boolean
}

type EditableColumnsContextType = {
  editableColumns: EditableSimulationTransactionColumns
}

const EditableColumnsContext = React.createContext<
  EditableColumnsContextType | undefined
>(undefined)

export const useEditableSimulationTransaction =
  (): EditableSimulationTransactionColumns => {
    const context = React.useContext(EditableColumnsContext)
    return context?.editableColumns ?? {}
  }

type Props = {
  editableColumns: EditableSimulationTransactionColumns
  children: React.ReactNode
}

export const EditableSimulationTransactionProvider: React.FC<Props> = ({
  editableColumns,
  children,
}) => {
  return (
    <EditableColumnsContext.Provider value={{ editableColumns }}>
      {children}
    </EditableColumnsContext.Provider>
  )
}
